import React, { useState, useEffect } from 'react';
import moment from 'moment';

function ExpenseForm({ gigId, expense, gig, onSave, onCancel }) {
  // Default to gig's start_date if available, otherwise today's date
  const defaultDate = gig?.start_date 
    ? moment(gig.start_date).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD');
  
  const [formData, setFormData] = useState({
    description: '',
    amount: '',
    expense_date: defaultDate,
    covered_by: 'self'
  });

  useEffect(() => {
    if (expense) {
      setFormData({
        description: expense.description || '',
        amount: expense.amount ? expense.amount.toString() : '',
        expense_date: expense.expense_date ? moment(expense.expense_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        covered_by: expense.covered_by || 'self'
      });
    } else {
      // When creating a new expense, default to gig's start_date
      const defaultDate = gig?.start_date 
        ? moment(gig.start_date).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD');
      setFormData({
        description: '',
        amount: '',
        expense_date: defaultDate,
        covered_by: 'self'
      });
    }
  }, [expense, gig]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.description || !formData.amount || !formData.expense_date) {
      alert('Please fill in all required fields');
      return;
    }

    onSave({
      id: expense?.id,
      gig_id: gigId,
      ...formData,
      amount: parseFloat(formData.amount),
      covered_by: formData.covered_by || 'self'
    });
  };

  return (
    <div className="expense-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="description">Description *</label>
          <input
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            placeholder="e.g., Office supplies, Travel, etc."
          />
        </div>

        <div className="form-group">
          <label htmlFor="amount">Amount (€) *</label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            required
            min="0"
            step="0.01"
            placeholder="50.00"
          />
        </div>

        <div className="form-group">
          <label htmlFor="expense_date">Date *</label>
          <input
            type="date"
            id="expense_date"
            name="expense_date"
            value={formData.expense_date}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="covered_by">Covered By *</label>
          <select
            id="covered_by"
            name="covered_by"
            value={formData.covered_by}
            onChange={handleChange}
            required
          >
            <option value="self">Self (Out of Pocket)</option>
            <option value="company">Company/Client (Reimbursed)</option>
          </select>
        </div>

        <div className="btn-group">
          <button type="submit" className="btn btn-primary">
            {expense ? 'Update Expense' : 'Add Expense'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default ExpenseForm;

